import { useEffect, useState } from "react";
import axios from "axios";
import you from "../images/boy.png";
import bot from "../images/happy.png";
import LoadingDots from "./LoadingDots";

// Image imports for carousel
import image1 from '../images/Broiler-Pre-Starter.png';
import image2 from '../images/BroCmix.png';
import image3 from '../images/SonaMax-Country-Chicken-Starter.png';
import image4 from '../images/SonaMax-Country-Chicken-Finisher.png';
import LastMenu2 from "./LastMenu2";

const SubFeeds = ({ feedId }) => {
    const [subFeeds, setSubFeeds] = useState([]); // Store sub-feed data
    const [time] = useState(new Date().toLocaleTimeString()); // Time display
    const [prodName, setProdName] = useState(""); // Product name
    const [index, setIndex] = useState(0); // Index for carousel navigation
    const [loading, setLoading] = useState(true); // Loading state for sub-feeds

    useEffect(() => {
        // Set product name based on feedId
        setProdName(feedId === 1 ? "Broiler Feed" : "Country Chicken Feed");

        // Fetch sub-feed data based on feedId
        axios
            .get(`https://poultry-chatbot-api.onrender.com/feeds/${feedId}`)  // API to fetch sub-feeds for selected feed
            .then((response) => {
                if (response.data?.length > 0) {
                    setSubFeeds(response.data); // Set sub-feed data
                } else {
                    alert("No Sub-Feeds found.");
                }
            })
            .catch((error) => {
                console.error("Error fetching sub-feed items:", error);
                alert("Failed to fetch sub-feed items.");
            })
            .finally(() => setLoading(false)); // Set loading to false after fetching data
    }, [feedId]); // Depend on feedId, re-fetch if feedId changes

    // Select images based on feedId
    const images = feedId === 1 ? [image1, image2] : [image3, image4];

    const moveLeft = () => {
        if (index > 0) setIndex(index - 1);
    };

    const moveRight = () => {
        if (index < subFeeds.length - 1) setIndex(index + 1);
    };

    return (
        <>
            <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time}
            </div>

            <div className="you-message">
                <div className="frame2">{prodName}</div>
            </div>

            {loading ? (
                <div className="frame1">
                    <LoadingDots />
                </div>
            ) : (
                <>
                    <div className="chatbot">
                        <img src={bot} alt="bot" className="bot" />
                        <div className="chatbot-time">{time}</div>
                    </div>

                    <div className="frame1">
                        {subFeeds.length > 0 ? (
                            <div className="carousel-container">
                                <button onClick={moveLeft} className="nav-button">
                                    &#60;
                                </button>

                                {/* Display the sub-feed item with image and description */}
                                <div className="food-item">
                                    <b style={{ fontSize: '18px' }}>{subFeeds[index]?.sub_feed_name}</b><br></br>
                                    <img
                                        src={images[index % images.length]}
                                        alt={subFeeds[index]?.sub_feed_name}
                                        className="carousel-image"
                                    />
                                    <p className="description">{subFeeds[index]?.description}</p>
                                </div>

                                <button onClick={moveRight} className="nav-button">
                                    &#62;
                                </button>
                            </div>
                        ) : (
                            <p>No sub-feed items found.</p>
                        )}
                    </div>
                    <LastMenu2 menu={2} />
                </>
            )}
            
        </>
    );
};

export default SubFeeds;
